import $ from "jquery/dist/jquery";

$(() => {
  let a_req = null;

  function doAutocomplete(q) {
    if (a_req) {
      a_req.abort();
    }
    const ael = $("#search-autocomplete");
    const ael_mobile = $("#search-autocomplete-mobile");
    a_req = $.get(window.NXURLS.URL_AUTOCOMPLETE, {
      q: q,
    })
      .done((d) => {
        ael.html(d.autocomplete);
        ael_mobile.html(d.autocompleteMobile);
        if ($("#search").is(":visible")) {
          ael.show();
        } else if ($("#search-mobile").is(":visible")) {
          ael_mobile.show();
        }
      })
      .fail(() => {
        ael.hide().html("");
      });
  }

  function doCancelAutocomplete() {
    if (a_req) {
      a_req.abort();
    }
    $("#search-autocomplete").hide().html("");
    $("#search-autocomplete-mobile").hide().html("");
  }

  $("#search:not(.no-autocomplete), #search-mobile:not(.no-autocomplete)")
    .keyup(function () {
      const q = $(this).val();
      let a_timeout = null;

      if (q.length >= 3) {
        if (a_timeout) {
          clearTimeout(a_timeout);
          a_timeout = null;
        }
        a_timeout = setTimeout(() => {
          doAutocomplete(q);
        }, 100);
      }
    })
    .blur(() => {
      setTimeout(doCancelAutocomplete, 250);
    });
});
